import { render } from "./VxPortfolio.vue?vue&type=template&id=d25ec962"
import script from "./VxPortfolio.vue?vue&type=script&lang=js"
export * from "./VxPortfolio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__